export class HybridCheck {
    constructor(attendanceType) {
        this.attendanceType = attendanceType;
        this._hybridCheckWrapperSelector = ".js-hybrid-check";
        this.wrapper = this.findHybridCheckWrapper();
        this.checkbox = this.findCheckbox();
        this.attendanceType.addEventListener("change", () => {
            this.toggleHybrid();
        });
        this.toggleHybrid();
    }
    findCheckbox() {
        const hybridCheckbox = this.wrapper?.querySelector('input[type="checkbox"]');
        if (hybridCheckbox === null) {
            throw new Error(`Hybrid checkbox inside its wrapper ${this._hybridCheckWrapperSelector} not found`);
        }
        return hybridCheckbox;
    }
    findHybridCheckWrapper() {
        const hybridCheckWrapper = document.querySelector(this._hybridCheckWrapperSelector);
        if (hybridCheckWrapper === null) {
            throw new Error(`Hybrid check wrapper with class ${this._hybridCheckWrapperSelector} not found`);
        }
        return hybridCheckWrapper;
    }
    toggleHybrid() {
        if (this.attendanceType.selectedOptions[0].dataset.hybrid === "true") {
            this.wrapper.style.display = "block";
            this.checkbox.required = true;
        }
        else {
            this.wrapper.style.display = "none";
            this.checkbox.required = false;
        }
    }
    static create(form) {
        const attendanceType = form.querySelector(".js-attendance-type");
        if (attendanceType === null) {
            return null;
        }
        return new HybridCheck(attendanceType);
    }
}
